import {Swiper, SwiperSlide, useSwiper} from "swiper/react";
import {useEffect, useRef, useState} from "react";
import {getBaseImagePath} from "../Utils";
import ModelImageInterface from "../../../interfaces/model/ModelImageInterface";

export default function Slider({images, altString} : {images: ModelImageInterface[], altString: string}) {
    // грязный хак - без него не работают стрелки перемещения слайдов
    const [isLoop, setIsLoop] = useState(false);
    const [slideIndex, setSlideIndex] = useState(0);

    const swiperRef = useRef();

    const swiper = useSwiper();

    useEffect(() => {
        console.log(swiper)
    }, []);

    return (<div className="product__kv-slider">
        <a className="product__kv-all-image btn btn-primary" href="/" onClick={(event) => { event.preventDefault()}}><i
            className="ico ico-left ico-eye-black ico-color"></i>Весь образ</a>
        <div className="product__kv-slider__wrap">
            <div className="product__kv-slider-main">
                <Swiper
                    loop={isLoop}
                    spaceBetween={5}
                    slidesPerView={1}
                    onSlideChange={(p1:any) => {
                        console.log(p1?.activeIndex)
                    }}
                    onSwiper={ (swiper:any) => {
                        swiperRef.current = swiper
                    }}
                    breakpoints={{
                        992: {
                            slidesPerView: 2
                        }
                    }}
                >
                    {images.map((image, index) => <SwiperSlide key={image.url} virtualIndex={index}>
                        <a key={image.url} className="slide" href="/" onClick={(event) => { event.preventDefault()}}>
                            <img  src={getBaseImagePath() + image.url} alt={altString + (index ? ' - ' + (index + 1) : '')}/>
                        </a>
                    </SwiperSlide>)}
                </Swiper>


            </div>
            <div className="product__kv-slider-add desk">
                {images.map((image, index) => <div key={image.url} className="slide"><img className={"pointer"} style={{border: (slideIndex === index ? "1" : "0") + "px solid grey" }} onClick={
                    () => {
                        // @ts-ignore
                        swiperRef.current.slideTo(index)
                        setSlideIndex(index)
                    }
                }
                    src={getBaseImagePath() + image.url} alt=""/></div>)}
            </div>
            <div className="product__kv-slider-controls desk">
                <div className="slick-btn slick-btn-prev" onClick={() => {
                    if(isLoop) {
                        // @ts-ignore
                        swiperRef.current.slidePrev()
                        setSlideIndex(slideIndex > 0 ? slideIndex-1 : images.length)
                    }else {
                        // @ts-ignore
                        swiperRef.current.slideTo(images.length)
                        setSlideIndex(images.length - 2)
                    }
                    setIsLoop(true)
                }}></div>
                <div className="slick-btn slick-btn-next" onClick={() => {
                    setIsLoop(true)
                    // @ts-ignore
                    swiperRef.current.slideNext()
                    setSlideIndex(slideIndex > images.length - 1 ? 0 : slideIndex+1)
                }}></div>
            </div>
            <a className="product__kv-back-page mob" href=""><i
                className="ico ico-arrow-left-b"></i></a>
        </div>
    </div>)
}